import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import "rxjs/add/operator/map"
import { Observable } from "rxjs/Observable";
import { Configuration } from "../app.constants";
import { FirmwareAsset } from "../admin/models/firmwareasset";
import { ApiResponse } from "../admin/apiresponse";
//import { AdalHttp } from "./adal.http.service";

@Injectable()
export class UserInfoService {

    private actionUrl: string;
    private headers: Headers;
    private apiResponse: ApiResponse;
    public currentUserInfo: any = {};

    constructor(private http: Http, private configuration: Configuration) {

        this.actionUrl = configuration.ServerWithApiUrl + "account";

        this.headers = new Headers();
        this.headers.append("Content-Type", "application/json");
    }

    public getUserInfo = (): Observable<Response> => {
        return this.http.get(this.actionUrl).map(res => {
            this.currentUserInfo = res.json();
            return this.currentUserInfo;
        });
    }
}


// WEBPACK FOOTER //
// ./app/services/userinfo.service.ts